import { Route } from '@angular/router';
import { ReferralListStore } from './stores/referral-list.store';

export const referralRoutes: Route[] = [
  {
    path: '',
    providers: [ReferralListStore],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './pages/referral-dashboard/referral-dashboard.component'
          ).then((mod) => mod.ReferralDashboardComponent),
      },
      {
        path: ':referralUid',
        data: { canChangePatient: true },
        loadComponent: () =>
          import('./pages/referral/referral.component').then(
            (mod) => mod.ReferralComponent
          ),
      },
    ],
  },
];
